const types = {
  SET_CURRENT_NEWS_LETTER: 'SET_CURRENT_NEWS_LETTER'
};
const state = {
  currentNewsLetter: null
};

const mutations = {
  [types.SET_CURRENT_NEWS_LETTER]: (state, value) => {
    state.currentNewsLetter = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
